import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Tappable } from '@vectord/components';

import {
  RESCHEDULE_CLASS_CONFIRMATION_REASON_OPTIONS,
  RESCHEDULE_CLASSES_STAGES,
  bulkRescheduleReasonSelector,
  rescheduleErrorsSelector,
  rescheduleClassesFormCommunicationsSelector,
  setBulkRescheduleCommunications,
  setBulkRescheduleReason,
  setRescheduleClassesStage,
} from 'features/classCreation';
import ConfirmRevisedScheduleButton from '../ConfirmRevisedScheduleButton';
import Field from 'components/Field';
import FieldErrors from 'components/FieldErrors';
import Input from 'components/Input';
import RevisedClassesScheduleTable from '../RevisedClassesScheduleTable';
import styles from './RescheduleConfirmation.module.scss';
import Select from 'components/Select';
import SelectNotificationMode from 'components/SelectNotificationMode';

function RescheduleConfirmation() {
  const dispatch = useDispatch();
  const errors = useSelector(rescheduleErrorsSelector);
  const communications = useSelector(
    rescheduleClassesFormCommunicationsSelector
  );
  const rescheduleReason = useSelector(bulkRescheduleReasonSelector);

  const handleGoBack = useCallback(() => {
    dispatch(setRescheduleClassesStage(RESCHEDULE_CLASSES_STAGES.details));
  }, [dispatch]);

  const handleReasonChange = useCallback(
    (option) => {
      dispatch(setBulkRescheduleReason(option));
    },
    [dispatch]
  );

  const handleInputReasonChange = useCallback(
    (e) => {
      dispatch(
        setBulkRescheduleReason({
          ...rescheduleReason,
          customReason: e.target.value,
        })
      );
    },
    [dispatch, rescheduleReason]
  );

  const handleCommsToggle = useCallback(
    (commType) => {
      dispatch(
        setBulkRescheduleCommunications({
          channel: commType,
          enabled: !communications[commType],
        })
      );
    },
    [communications, dispatch]
  );

  return (
    <div className={styles.root}>
      <Field
        label="Proposed Schedule"
        name="revised_schedule"
        clientErrors={errors}
      >
        <RevisedClassesScheduleTable />
      </Field>
      <FieldErrors
        className={styles.baseError}
        errors={errors}
        name="base"
        prefixName={false}
      />
      <div className={styles.rescheduleReasonField}>
        <Select
          className={styles.selectReason}
          placeholder="Select reason for rescheduling class"
          options={RESCHEDULE_CLASS_CONFIRMATION_REASON_OPTIONS}
          value={rescheduleReason}
          onChange={handleReasonChange}
          menuPlacement="auto"
        />
        {rescheduleReason?.value === 8 && (
          <div className={styles.inputField}>
            <Input
              required
              className={styles.inputFieldOtherReason}
              placeholder="Please Share reason"
              value={rescheduleReason?.customReason || ''}
              onChange={handleInputReasonChange}
            />
            <FieldErrors
              errors={errors}
              name="reason"
              prefixName={false}
            />
          </div>
        )}
      </div>
      <SelectNotificationMode
        communications={communications}
        handleCommsToggle={handleCommsToggle}
      />
      <div className="row align-c">
        <ConfirmRevisedScheduleButton />
        <Tappable
          className="btn btn-long btn-primary btn-inverted"
          onClick={handleGoBack}
        >
          Go Back
        </Tappable>
      </div>
    </div>
  );
}

export default RescheduleConfirmation;
